import { Link } from 'lucide-react';
import React from 'react';
import type { Device } from '@types';
import { BaseActionButton, BaseActionButtonProps } from '../BaseActionButton';

export interface PairDeviceButtonProps
  extends Omit<BaseActionButtonProps, 'action'> {
  device: Device;
  onPair: (device: Device) => void;
}

export const PairDeviceButton: React.FC<PairDeviceButtonProps> = ({
  device,
  onPair,
  onSuccess,
  onError,
  confirmBeforeAction = false,
  children,
  tooltip = 'Abbina il sensore ad un dispositivo',
  ...buttonProps
}) => {
  const handlePair = async () => {
    onPair(device);
  };

  return (
    <BaseActionButton
      action={handlePair}
      tooltip={tooltip}
      confirmBeforeAction={confirmBeforeAction}
      onSuccess={onSuccess}
      onError={onError}
      showNotification={false} // La logica di pairing gestisce le notifiche
      leftSection={<Link size={16} />}
      color='green'
      variant='light'
      size='xs'
      {...buttonProps}
    >
      {children || 'Abbina ad un dispositivo'}
    </BaseActionButton>
  );
};
